import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HoudiniPhotospheresModule } from 'houdini-photospheres/dist/houdini-photospheres';
// import { HoudiniPhotospheresModule } from 'houdini-photospheres-local'; // For local version
import { UtilsService } from './services/utils.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HoudiniPhotospheresModule
  ],
  providers: [
    UtilsService,
    { provide: Window, useValue: window },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
